'use client'

import { HeartOff } from 'lucide-react'
import ProductCard from '../product/ProductCard'

export default function Wishlist({ wishlist, vendor }: { wishlist: any, vendor: any }) {
  const isLoading = wishlist === undefined || wishlist === null
  const products: any[] = wishlist?.products || []

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 lg:px-8 pt-10 pb-16">
      <div className="flex items-center justify-between mb-7 gap-4 flex-wrap">
        <div className="text-[10px] font-semibold uppercase tracking-[0.22em]" style={{ color: '#a8a8b3' }}>
          {products.length > 0 ? `${products.length} хадгалсан бараа` : 'Хадгалсан бараа'}
        </div>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="aspect-4/5 w-full rounded-xl animate-pulse" style={{ background: 'rgba(255,255,255,0.04)' }} />
          ))}
        </div>
      ) : products.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-12">
          {products.map((product: any, i: number) => (
            <ProductCard
              key={`${product.id}-${product.variant?.id || `wishlist-${i}`}`}
              product={product}
              vendor={vendor}
              showVariantName
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-3 py-24" style={{ color: 'rgba(255,255,255,0.5)' }}>
          <HeartOff className="h-8 w-8" />
          <div className="text-[14px]">Хадгалсан бараа байхгүй байна</div>
        </div>
      )}
    </div>
  )
}
